import { Component, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { Race } from '../race';
import { shareReplay, switchMap } from 'rxjs/operators';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'mc-race-settings',
  templateUrl: './race-settings.component.html',
  styleUrls: ['./race-settings.component.scss']
})
export class RaceSettingsComponent implements OnInit {

  race$: Observable<Race> = this.activatedRoute.parent.data.pipe(
    switchMap((data) => data.race$ as Observable<Race>),
    shareReplay({
      refCount: true,
      bufferSize: 1
    })
  );

  constructor(
    private readonly activatedRoute: ActivatedRoute
  ) { }

  ngOnInit(): void {
  }
}
